export enum FeedbackSubjectEnum {
  subject = 'Feedback - Customer Rules',
}
